import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import "./Modal.css";
import "./PromptModal.css";

const PromptModal = (props) => {
  const [Inputs, SetInputs] = useState([]);

  useEffect(() => {
    SetInputs(props.PromptModalInputs);
  }, [props.PromptModalInputs]);

  const handleButtonClick = (button) => {
    if (button.Method != null) button.Method(Inputs);
    props.onHide();
  };

  const handleInputChanged = (e, input) => {
    const index = Inputs.findIndex((x) => x.name === input.name);
    if (index === -1) return;
    Inputs[index].value = e.target.value;
    SetInputs(Inputs);
  };

  // Submits the primary action button on Enter — not literally the one
  // titled "OK", since callers use other verbs too ("Next", "Continue",
  // "Yes, search", etc.). By convention across every PromptModal caller in
  // this codebase, the action button (Method != null) is always listed
  // first and Cancel/Skip (Method: null) last, so "the first button with a
  // Method" is the same thing a mouse click on the primary button would do.
  const onKeyPress = (event) => {
    if (event.charCode === 13) {
      const primary = props.PromptModalButtons.find((button) => button.Method != null);
      if (primary) handleButtonClick(primary);
    }
  };

  const isSingle = props.PromptModalButtons.length === 1;

  return (
    <div className="modal">
      <Modal
        show={props.show}
        animation={false}
        dialogClassName="pm-dialog"
        aria-labelledby="pm-title"
        centered
        onHide={props.onHide}
      >
        <Modal.Body style={{ padding: 0 }}>
          <div className="pm-shell">

            {/* ── Header ── */}
            <div className="pm-header">
              <div className="pm-header-icon">
                <FontAwesomeIcon icon={solid("pen-to-square")} />
              </div>
              <h2 className="pm-title" id="pm-title">{props.PromptModalTitle}</h2>
              <button className="pm-close" onClick={props.onHide}>
                <FontAwesomeIcon icon={solid("xmark")} />
              </button>
            </div>

            {/* ── Body ── */}
            {(props.PromptModalMessage || Inputs.length > 0) && (
              <div className="pm-body">
                {props.PromptModalMessage ? (
                  <p className="pm-message">{props.PromptModalMessage}</p>
                ) : null}
                {Inputs.map((input, i) => (
                  <div key={i} className="pm-field">
                    {input.name && <label className="pm-label">{input.name}</label>}
                    {props.area ? (
                      <textarea
                        ref={(el) => i === 0 && el && el.focus()}
                        className="pm-textarea"
                        placeholder="Enter Text"
                        defaultValue={input.value}
                        onChange={(e) => handleInputChanged(e, input)}
                      />
                    ) : (
                      <input
                        ref={(el) => i === 0 && el && el.focus()}
                        className="pm-input"
                        type="text"
                        placeholder="Enter Text"
                        defaultValue={input.value}
                        onChange={(e) => handleInputChanged(e, input)}
                        onKeyPress={onKeyPress}
                      />
                    )}
                  </div>
                ))}
              </div>
            )}

            {/* ── Footer ── */}
            <div className={`pm-footer${isSingle ? " pm-single" : ""}`}>
              {props.PromptModalButtons.map((button, i) => {
                const isAction = button.Method != null;
                const isLast = i === props.PromptModalButtons.length - 1;
                let cls = "pm-btn ";
                if (isSingle) {
                  cls += isAction ? "pm-btn-action" : "pm-btn-cancel";
                } else if (!isAction || isLast) {
                  cls += "pm-btn-cancel";
                } else {
                  cls += "pm-btn-action";
                }
                return (
                  <button
                    key={i}
                    className={cls}
                    onClick={() => handleButtonClick(button)}
                  >
                    {button.Title}
                  </button>
                );
              })}
            </div>

          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default PromptModal;
